<script setup>
useHead({
  title: 'Cookie Policy | DigitXS',
  meta: [{ name: 'description', content: 'Cookie Policy | DigitXS' }],
})

onMounted(() => {
  const externalScript = document.createElement('script')
  externalScript.setAttribute(
    'src',
    'https://consent.cookiebot.com/f23518b6-0845-4b04-bae1-0ded5635aebb/cd.js',
  )
  externalScript.setAttribute('id', 'CookieDeclaration')
  const sectionElement = document.querySelector('.cookie-script')
  sectionElement.appendChild(externalScript)
})
</script>

<template>
  <div class="cookie-page row-270-20 p-bot-1 max p-top-1a">
    <h1 class="intro-page-title text-3">Cookie Policy</h1>
    <section class="cookie-script text-2"></section>
  </div>
</template>
